import * as Sentry from "@sentry/nextjs"

export const copyToClipboard = (content: string) => {
  try {
    if (!navigator.clipboard) {
      // Deprecated method mainly for Firefox I guess
      const el = document.createElement("textarea")
      el.value = content
      document.body.appendChild(el)
      el.select()
      // Store currently focused element if exists and focus the textarea. This old method wont work without this when used eg. inside Modal
      const focusedElement = document.activeElement as HTMLElement | null
      el.focus()
      document.execCommand("copy")
      document.body.removeChild(el)
      // Re-focus possibly
      focusedElement?.focus()
    } else {
      navigator.clipboard.writeText(content)
    }
  } catch (error) {
    // Catch possible errors so copyting to clipboard wont fail the whole app
    console.error("Failed to copy contents to clipboard", error)
    Sentry.captureException(error, {
      extra: {
        component: "CopyToClipboard",
      },
    })
  }
}
